import { useCallback } from "react";
import ReduxFetchState from "redux-fetch-state";
import { put, takeEvery } from "redux-saga/effects";
import axios from "../../../../Utils/axiosConfig";
import { getCurrentLanguage } from "../../../../Utils/sagaHelpers";
import { useAppDispatch, useAppSelector } from "../../../../Hooks/useStore";
import { alert } from "../../../../Utils/toast";

export type AgencyListLoadAction = {
    type: string;
};

export type Agency = {
    id: number;
    user_id: number;
    username: string;
    name: string;
    link: string;
    logo_path: string;
    slogan: string;
    color: string;
    bio: string | null;
};

export type AgencyListData = {
    data: {
    "agencies": Agency[]
    };
};

const AgencyList = new ReduxFetchState<
    AgencyListData | null,
    any
>("agencyList");

export function* watchAgencyList(action: AgencyListLoadAction) {
    try {
        const lang: "fa" | "en" = yield getCurrentLanguage();

        const data: AgencyListData = yield axios({
            url: `api/v1/ai/agency/list`,
            method: "GET",
            headers: {
                "Content-Type": "multipart/form-data",
                lang,
            },
        });

        yield put(AgencyList.actions.loadSuccess({ data: data.data }));
    } catch (e: any) {
        alert({
            message: e?.response?.data?.error ?? "مشکلی پیش آمده",
            type: "error",
        });
        yield put(AgencyList.actions.loadFailure(e.message));
    }
}

export function* agencyListSagas() {
    yield takeEvery(AgencyList.actionTypes.load, watchAgencyList);
}

export function useAgencyList() {
    const { loading, data, ...agencyListState } = useAppSelector(
        (state) => state.agencyList,
    );
    const dispatch = useAppDispatch();

    const dispatchAgencyList = useCallback(
        () => {
            dispatch(AgencyList.actions.load());
        },
        [dispatch],
    );

    return {
        ...agencyListState,
        dispatchAgencyList,
        agencyListLoading: loading,
        agencyListData: data,
    };
}

export const {
    actionTypes: agencyListActionsTypes,
    actions: agencyListActions,
    reducer: agencyListReducer,
} = AgencyList;